import AgentsAPI from 'dashboard/api/agents/agents';
import { throwErrorMessage } from 'dashboard/store/utils/api';

const SET_RULES = 'SET_AI_RULES';
const ADD_RULE = 'ADD_AI_RULE';
const UPDATE_RULE = 'UPDATE_AI_RULE';
const REMOVE_RULE = 'REMOVE_AI_RULE';
const SET_UI_FLAG = 'SET_AI_RULES_UI_FLAG';

export default {
  namespaced: true,
  state: {
    rules: [],
    uiFlags: {
      fetchingList: false,
      creating: false,
      updating: false,
      deleting: false,
      reordering: false,
    },
  },
  getters: {
    getRules: state => state.rules.sort((a, b) => a.priority - b.priority),
    getUIFlags: state => state.uiFlags,
    getRuleById: state => id =>
      state.rules.find(rule => rule.id === Number(id)) || {},
    getRulesByType: state => ruleType =>
      state.rules.filter(rule => rule.rule_type === ruleType),
    getActiveRules: state => state.rules.filter(rule => rule.active),
  },
  mutations: {
    [SET_UI_FLAG](state, data) {
      state.uiFlags = { ...state.uiFlags, ...data };
    },
    [SET_RULES](state, rules) {
      state.rules = rules;
    },
    [ADD_RULE](state, rule) {
      state.rules.push(rule);
    },
    [UPDATE_RULE](state, updatedRule) {
      const index = state.rules.findIndex(r => r.id === updatedRule.id);
      if (index !== -1) {
        state.rules.splice(index, 1, updatedRule);
      }
    },
    [REMOVE_RULE](state, ruleId) {
      state.rules = state.rules.filter(r => r.id !== ruleId);
    },
  },
  actions: {
    async get({ commit }, { agentId, inboxId = null }) {
      commit(SET_UI_FLAG, { fetchingList: true });
      try {
        const response = await AgentsAPI.getRules(agentId, inboxId);
        const payload = response.data.payload || response.data || [];
        commit(SET_RULES, payload);
        return payload;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(SET_UI_FLAG, { fetchingList: false });
      }
    },
    async create({ commit }, { agentId, data }) {
      commit(SET_UI_FLAG, { creating: true });
      try {
        const response = await AgentsAPI.createRule(agentId, data);
        commit(ADD_RULE, response.data);
        return response.data;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(SET_UI_FLAG, { creating: false });
      }
    },
    async update({ commit }, { agentId, ruleId, data }) {
      commit(SET_UI_FLAG, { updating: true });
      try {
        const response = await AgentsAPI.updateRule(agentId, ruleId, data);
        commit(UPDATE_RULE, response.data);
        return response.data;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(SET_UI_FLAG, { updating: false });
      }
    },
    async delete({ commit }, { agentId, ruleId }) {
      commit(SET_UI_FLAG, { deleting: true });
      try {
        await AgentsAPI.deleteRule(agentId, ruleId);
        commit(REMOVE_RULE, ruleId);
        return ruleId;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(SET_UI_FLAG, { deleting: false });
      }
    },
    async reorder({ commit }, { agentId, ruleIds }) {
      commit(SET_UI_FLAG, { reordering: true });
      try {
        const response = await AgentsAPI.reorderRules(agentId, ruleIds);
        commit(SET_RULES, response.data);
        return response.data;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(SET_UI_FLAG, { reordering: false });
      }
    },
  },
};
